import { render, staticRenderFns } from "./MainAdminNavigation.vue?vue&type=template&id=5e43a3b7&scoped=true&"
import script from "./MainAdminNavigation.vue?vue&type=script&lang=js&"
export * from "./MainAdminNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MainAdminNavigation.vue?vue&type=style&index=0&id=5e43a3b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e43a3b7",
  null
  
)

export default component.exports